export default "/images/fa0d97a176516d0ce63b006554c3b33d.avif";